import { useState } from "react";

export const useForm = (initialState = {}) => {
  const [formValues, setFormValues] = useState(initialState);

  const reset = (nuevoState = null) => {
    setFormValues(nuevoState ?? initialState);
  };

  const updateState = (datos) => {
    let nuevoState = formValues;

    console.log("Nuevo state");

    datos.map((d) => {
      nuevoState[d.name] = d.value;
    });

    setFormValues({
      ...nuevoState,
    });
  };
  const updateValue = (name, value, index = null) => {
    if (index != null) {
      let valores = formValues[name];
      valores[index] = value;
      setFormValues({
        ...formValues,
        [name]: valores,
      });
    } else {
      console.log("Update value " + name);
      console.log("Update value " + value);
      setFormValues({
        ...formValues,
        [name]: value,
      });
    }
  };

  const handleInputChange = ({ target }) => {
    setFormValues({
      ...formValues,
      [target.name]: target.value,
    });
  };

  return [formValues, handleInputChange, reset, updateValue, updateState];
};
